<template>
    <tr class="autoenrolments__list_table_item">
        <td class="autoenrolments__list_table_name">{{ itemName }}</td>
        <td class="autoenrolments__list_table_target">{{ itemTargetsNames }}</td>
        <td class="autoenrolments__list_table_bundle">{{ itemBundle }}</td>
        <td class="autoenrolments__list_table_status">
            <component-status :status="itemStatus"></component-status>
        </td>
        <td class="autoenrolments__list_table_actions">
            <div class="columns">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :name="'autoenrolments-list-table-item-actions-edit'"
                        :theme="'default'"
                        :to="{ name: 'ebs-autoenrolments-edit', params: { id: itemId } }"
                    >Edit</component-button>
                </div>
                <div class="column is-narrow">
                    <component-button-menu
                        :name="'autoenrolments-list-table-item-actions-menu'"
                        :buttons="buttonMenuList"
                        @emit-archive="performArchiveAutoenrolments"
                        @emit-view-users="redirectToUsers"
                    ></component-button-menu>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>

import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import ComponentTextList from '@/components/default/shared/ComponentTextList'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import { User } from '@/User'

export default {
  name: 'autoenrolments-list-groups-table-item',
  components: { ComponentStatus, ComponentTextList, ComponentButtonMenu, ComponentButton },
  data () {
    return {
      user: new User()
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    buttonMenuList () {
      let arrList = []

      if (this.user.isSuperadmin() || this.user.isUserAdministrator() || this.user.isMasterAdministrator() || this.user.isOrgUnitManager()) {
        arrList.push({
          key: 'view-users',
          name: 'View users'
        })
        arrList.push({
          key: '',
          name: ''
        })
      }
      arrList.push({
        key: 'archive',
        name: 'Archive',
        icon: true,
        iconName: 'trash-2',
        danger: true
      })

      return arrList
    },
    itemId () {
      return this.item.id
    },
    itemName () {
      return this.item.name
    },
    itemTargetsNames () {
      let items = this.item.targets
      let itemsFiltered = items && items.length ? items.filter(obj => obj.name) : ''
      let itemsMapped = itemsFiltered && itemsFiltered.length ? itemsFiltered.map(obj => obj.name) : ''
      let outputItems = itemsMapped ? itemsMapped.join(', ') : ''
      return outputItems
    },
    itemTargetsOutputByComma () {
      let items = this.item.targets
      let itemsFiltered = items && items.length ? items.filter(obj => obj.name) : ''
      let itemsMapped = itemsFiltered && itemsFiltered.length ? itemsFiltered.map(obj => obj.id + ';' + obj.name) : ''
      let outputItems = itemsMapped ? itemsMapped.join(',') : ''
      return outputItems
    },
    itemBundle () {
      let items = this.item.items
      let itemsFiltered = items && items.length ? items.filter(obj => obj.name) : ''
      let itemsMapped = itemsFiltered && itemsFiltered.length ? itemsFiltered.map(obj => obj.name) : ''
      let outputItems = itemsMapped ? itemsMapped.join(', ') : ''
      return outputItems
    },
    itemStatus () {
      return this.item.active === 1 || this.item.active === '1' ? 'active' : 'inactive'
    }
  },
  methods: {
    performArchiveAutoenrolments () {
      this.$store.dispatch('lmsUserAutoenrolmentRemove', this.itemId).then(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Auto-enrolment archive',
          message: 'Auto-enrolment has been successfully archived.',
          status: 'success'
        })
        this.$eventBus.$emit('get-auto-enrolments')
      }).catch(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Auto-enrolment archive',
          message: `Auto-enrolment hasn't been archived.`,
          status: 'error'
        })
      })
    },
    redirectToUsers () {
      this.$router.push({ name: 'lms-superadmin-user-list', query: { groups: this.itemTargetsOutputByComma } })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/autoenrolments/autoenrolmentslisttableitem";
</style>
